var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1912_5544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 8.41111C11.1111 8.90203 10.7131 9.3 10.2222 9.3C9.7313 9.3 9.33333 8.90203 9.33333 8.41111V3.88889C9.33333 3.39797 8.93536 3 8.44444 3C7.95352 3 7.55556 3.39797 7.55556 3.88889V8.41111C7.55556 8.90203 7.15759 9.3 6.66667 9.3C6.17575 9.3 5.77778 8.90203 5.77778 8.41111V3.88889C5.77778 3.39797 5.37981 3 4.88889 3C4.39797 3 4 3.39797 4 3.88889V9.3C4 10.88 5.01186 12.2132 6.41471 12.6912C6.91437 12.8615 7.33333 13.2841 7.33333 13.812V20C7.33333 20.5523 7.78105 21 8.33333 21H8.55556C9.10784 21 9.55556 20.5523 9.55556 20V13.812C9.55556 13.2841 9.97452 12.8615 10.4742 12.6912C11.877 12.2132 12.8889 10.88 12.8889 9.3V3.88889C12.8889 3.39797 12.4909 3 12 3C11.5091 3 11.1111 3.39797 11.1111 3.88889V8.41111ZM15.5556 6.6V12.8C15.5556 13.3523 16.0033 13.8 16.5556 13.8H16.7778C17.3301 13.8 17.7778 14.2477 17.7778 14.8V20C17.7778 20.5523 18.2255 21 18.7778 21H19C19.5523 21 20 20.5523 20 20V4C20 3.44772 19.5468 2.98979 19.0078 3.11029C17.0316 3.55213 15.5556 5.23619 15.5556 6.6Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1912_5544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantWhite);
export default __webpack_public_path__ + "static/media/restaurant-white.18a1515feb96d93e0c8f7c0bee543a83.svg";
export { ForwardRef as ReactComponent };